import { css } from '@emotion/react'

import { canUseWindow, sendEmail } from '@/utils/browser'
import media from '@/layout/media-queries'
import Layout from '@/layout'

import PageNotFoundIcon from '@/assets/icons/page-not-found.inline.svg'
import useHydrationContext from '@/hooks/useHydrationContext'

const containerCss = (theme) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Colfax;

  h1 {
    text-align: center;
    margin-bottom: 1rem;
    margin-top: 0;
    font-size: calc(1.71098rem + 0.87648 * (100vw - 36rem) / 39);
  }

  .label {
    padding: 0 10px;
    text-align: center;

    @media screen and (max-width: ${media.SMALL}) {
      height: 3.75rem;
    }
  }

  li {
    margin-left: 20px;
    margin-bottom: 5px;
    width: 300px;
  }

  .error-page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    justify-content: space-between;
  }

  .main {
    font-size: 1.125rem;
    margin-top: 7rem;

    @media screen and (max-width: calc(${media.MEDIUM} - 33px)) {
      margin-top: 2rem;
    }

    @media screen and (max-width: ${media.SMALL}) {
      margin-bottom: 6rem;
    }
  }

  .error-image {
    display: inline-block;
    position: relative;

    @media screen and (max-width: ${media.SMALL}) {
      margin-bottom: 0.5rem;
    }

    svg,
    img {
      max-width: 100%;
      height: auto;
    }

    &__text {
      position: absolute;
      top: 50%;
      left: 20%;
      color: ${theme.colors.yellow};
      font-size: 84px;

      @media screen and (max-width: calc(${media.SMALL} - 275px)) {
        font-size: 17vw;
      }
    }
  }
`

const supportMail = 'support@livechatinc.com'

const PageNotFound = () => {
  const hydrated = useHydrationContext()

  if (!hydrated) {
    return null
  }

  return (
    <Layout>
      <div css={containerCss}>
        <main className="main">
          <div className="container">
            <h1>
              <span className="error-image">
                <PageNotFoundIcon />
                <span className="error-image__text">404</span>
              </span>
              <br />
              Page Not Found
            </h1>
            <div className="error-content">
              <div>
                <div className="label">
                  You can report this problem to our support team:
                </div>
                <ul>
                  <li>
                    {/* eslint-disable jsx-a11y/anchor-is-valid */}
                    <a
                      href="#"
                      onClick={() => {
                        if (
                          canUseWindow &&
                          window.LC_API &&
                          window.LC_API.is_loaded()
                        ) {
                          const { LC_API } = window

                          if (LC_API) {
                            LC_API.open_chat_window()
                          }
                        }
                      }}
                    >
                      start a chat
                    </a>
                  </li>
                  <li>
                    email us:{' '}
                    <a
                      href={`mailto:${supportMail}`}
                      alt="mail support"
                      onClick={(e) => {
                        e.preventDefault()
                        sendEmail(supportMail)
                      }}
                    >
                      {supportMail}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </main>
      </div>
    </Layout>
  )
}

export default PageNotFound
